



















import Vue from 'vue';
import DvFilterPopover from '@/components/util/DvFilterPopover.vue';
import { WeaponTypeName } from '@/models/items/ItemEnums';

interface IEntry {
    id: number;
    label: string;
}

//  -1 is a real value in _NeedWeaponType1/2 meaning "no weapon requirement",
//  and it is added here rather than by editing the shared WeaponTypeName map,
//  which describes items and has no such member.
const ENTRIES: IEntry[] = [{ id: -1, label: 'No weapon' }].concat(
    Object.keys(WeaponTypeName)
        .map(Number)
        .filter((id) => !isNaN(id))
        .sort((a, b) => a - b)
        .map((id) => ({ id, label: (WeaponTypeName as Record<number, string>)[id] })),
);

export default Vue.extend({
    components: { DvFilterPopover },
    props: {
        //  Controlled component: the parent owns the selection and the URL.
        value: { type: Array as () => number[], default: () => [] },
    },
    computed: {
        entries(): IEntry[] {
            return ENTRIES;
        },
    },
    methods: {
        toggle(id: number, checked: boolean) {
            const set = new Set(this.value);
            if (checked) {
                set.add(id);
            } else {
                set.delete(id);
            }
            this.$emit('select', [...set].sort((a, b) => a - b));
        },
        emitAll() {
            this.$emit('select', ENTRIES.map((e) => e.id));
        },
    },
});
